import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { alertsAPI } from '../services/api';

const BASE_NAV = [
  { key: 'garagem', label: 'Garagem', path: '/garagem', icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 16H9m10 0h3v-3.15a1 1 0 0 0-.84-.99L16 11l-2.7-3.6a1 1 0 0 0-.8-.4H5.24a2 2 0 0 0-1.8 1.1l-.8 1.63A6 6 0 0 0 2 12.42V16h2"/><circle cx="6.5" cy="16.5" r="2.5"/><circle cx="16.5" cy="16.5" r="2.5"/></svg> },
  { key: 'alertas', label: 'Alertas', path: '/alertas', badge: true, icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg> },
  { key: 'profissionais', label: 'Profissionais', path: '/profissionais', icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg> },
  { key: 'relatorios', label: 'Relatórios', path: '/relatorios', icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg> },
  { key: 'servicos', label: 'Serviços', path: '/servicos', icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg> },
];

const PRO_NAV = { key: 'pro', label: 'Minha Oficina', path: '/pro', icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg> };

const ACCOUNT_ITEMS = [
  { key: 'perfil', label: 'Perfil', path: '/perfil', icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg> },
];

export default function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [alertCount, setAlertCount] = useState(0);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;

  useEffect(() => {
    alertsAPI.list()
      .then(r => {
        const alerts = r.alerts || [];
        setAlertCount(alerts.filter(a => a.is_active).length);
      })
      .catch(() => {});
  }, [path]);

  const firstName = user?.name?.split(' ')[0] || 'Usuário';
  const initials = user?.name ? user.name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) : 'U';

  const isPro = user?.role === 'professional';
  const NAV_ITEMS = isPro ? [...BASE_NAV, PRO_NAV] : BASE_NAV;

  const isActive = (itemPath) => {
    if (itemPath === '/garagem') return path === '/garagem' || path.startsWith('/garagem/') || path.startsWith('/vehicles');
    if (itemPath === '/pro') return path === '/pro';
    return path === itemPath;
  };

  const handleNav = (itemPath) => {
    navigate(itemPath);
    setSidebarOpen(false);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <>
      <style>{LAYOUT_CSS}</style>

      {/* Mobile overlay */}
      {sidebarOpen && <div className="layout-overlay" onClick={() => setSidebarOpen(false)} />}

      <div className="layout-app">
        {/* ── Sidebar ────────────────── */}
        <aside className={`layout-sidebar ${sidebarOpen ? 'open' : ''}`}>
          <div className="layout-sidebar-brand" onClick={() => handleNav('/garagem')} style={{ cursor: 'pointer' }}>
            <img src="/nico-1.png" alt="NICO" />
          </div>

          {NAV_ITEMS.map(item => (
            <div
              key={item.key}
              className={`layout-nav-item ${isActive(item.path) ? 'active' : ''}`}
              onClick={() => handleNav(item.path)}
            >
              {item.icon}
              {item.label}
              {item.badge && alertCount > 0 && <span className="layout-nav-badge">{alertCount}</span>}
            </div>
          ))}

          <div className="layout-sidebar-section">Conta</div>

          {ACCOUNT_ITEMS.map(item => (
            <div
              key={item.key}
              className={`layout-nav-item ${isActive(item.path) ? 'active' : ''}`}
              onClick={() => handleNav(item.path)}
            >
              {item.icon}
              {item.label}
            </div>
          ))}

          <div className="layout-nav-item" onClick={handleLogout}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
            Sair
          </div>

          {/* Dica do Nico */}
          <div className="layout-sidebar-foot">
            <span className="layout-foot-lbl">Dica do Nico</span>
            <p className="layout-foot-msg">Mantenha seus serviços em dia para valorizar seu veículo na hora da venda!</p>
            <span className="layout-foot-btn" onClick={() => handleNav('/profissionais')}>Ver oficinas</span>
          </div>
        </aside>

        {/* ── Main ───────────────────── */}
        <div className="layout-main">
          {/* Topbar */}
          <header className="layout-topbar">
            <button className="layout-mobile-toggle" onClick={() => setSidebarOpen(!sidebarOpen)} aria-label="Menu">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
            </button>

            <div className="layout-topbar-spacer" />

            <div className="layout-topbar-actions">
              <button className="layout-icon-btn" onClick={() => navigate('/alertas')} aria-label="Notificações">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
                <span className="layout-dot" />
              </button>

              <div className="layout-user-chip" onClick={() => navigate('/perfil')}>
                <div className="layout-avatar">{initials}</div>
                <div className="layout-user-info">
                  <b>{user?.name || 'Usuário'}</b>
                  <small>{firstName}</small>
                </div>
              </div>
            </div>
          </header>

          {/* Page content */}
          <div className="layout-content">
            {children}
          </div>
        </div>
      </div>
    </>
  );
}

const LAYOUT_CSS = `
/* ── Layout Variables ───────────────────── */
:root {
  --lo-primary: #14562e;
  --lo-primary-dark: #0f4023;
  --lo-primary-mid: #1a6b3a;
  --lo-primary-soft: #e6f0e9;
  --lo-secondary: #e97117;
  --lo-secondary-soft: #fdece0;
  --lo-cream: #f4ede0;
  --lo-cream-2: #ede4d1;
  --lo-text: #183d24;
  --lo-text-muted: #6a7268;
  --lo-white: #ffffff;
  --lo-stroke: #e5ddc9;
  --lo-sidebar-w: 260px;
  --lo-header-h: 70px;
  --lo-radius: 12px;
  --lo-shadow-sm: 0 2px 8px rgba(15,64,35,.05);
  --lo-shadow-md: 0 8px 24px rgba(15,64,35,.09);
  --lo-shadow-lg: 0 20px 48px rgba(15,64,35,.14);
}

/* ── App Grid ──────────────────────────── */
.layout-app {
  display: grid;
  grid-template-columns: var(--lo-sidebar-w) 1fr;
  min-height: 100vh;
}

/* ── Sidebar ───────────────────────────── */
.layout-sidebar {
  background: var(--lo-white);
  border-right: 1px solid var(--lo-stroke);
  padding: 22px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: sticky;
  top: 0;
  height: 100vh;
  overflow-y: auto;
  z-index: 70;
}
.layout-sidebar-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 10px;
  margin-bottom: 24px;
}
.layout-sidebar-brand img {
  height: 34px;
  width: auto;
}
.layout-nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: var(--lo-radius);
  color: var(--lo-text);
  font-family: 'DM Sans', sans-serif;
  font-weight: 500;
  font-size: 14.5px;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  border: 1px solid transparent;
}
.layout-nav-item svg {
  width: 20px;
  height: 20px;
  flex: none;
}
.layout-nav-item:hover {
  background: var(--lo-cream);
}
.layout-nav-item.active {
  background: var(--lo-primary);
  color: #fff;
}
.layout-nav-item.active .layout-nav-badge {
  background: #fff;
  color: var(--lo-primary);
}
.layout-nav-badge {
  margin-left: auto;
  background: var(--lo-secondary);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 999px;
}
.layout-sidebar-section {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.6px;
  color: var(--lo-text-muted);
  padding: 14px 14px 6px;
}

/* Sidebar foot - Dica do Nico */
.layout-sidebar-foot {
  margin-top: auto;
  padding: 16px;
  border-radius: var(--lo-radius);
  background: var(--lo-primary);
  color: #fff;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.layout-foot-lbl {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 1.4px;
  opacity: 0.7;
  font-weight: 700;
}
.layout-foot-msg {
  font-size: 13.5px;
  line-height: 1.4;
  margin: 0;
}
.layout-foot-btn {
  background: #fff;
  color: var(--lo-primary);
  padding: 8px 14px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  align-self: flex-start;
  cursor: pointer;
  transition: background 0.15s;
}
.layout-foot-btn:hover {
  background: var(--lo-cream);
}

/* ── Main ──────────────────────────────── */
.layout-main {
  display: flex;
  flex-direction: column;
  min-width: 0;
  background: var(--lo-cream);
  overflow-x: hidden;
}

/* ── Topbar ─────────────────────────────── */
.layout-topbar {
  height: var(--lo-header-h);
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 0 32px;
  border-bottom: 1px solid var(--lo-stroke);
  position: sticky;
  top: 0;
  z-index: 20;
  backdrop-filter: blur(10px);
  background: rgba(244, 237, 224, 0.85);
}
.layout-mobile-toggle {
  display: none;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid var(--lo-stroke);
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.layout-mobile-toggle svg {
  width: 20px;
  height: 20px;
}
.layout-topbar-spacer {
  flex: 1;
}
.layout-topbar-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
  flex-shrink: 0;
}
.layout-icon-btn {
  width: 42px;
  height: 42px;
  border-radius: var(--lo-radius);
  background: #fff;
  border: 1px solid var(--lo-stroke);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}
.layout-icon-btn:hover {
  border-color: var(--lo-primary);
  background: var(--lo-primary-soft);
}
.layout-icon-btn svg {
  width: 18px;
  height: 18px;
}
.layout-dot {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 9px;
  height: 9px;
  background: var(--lo-secondary);
  border-radius: 50%;
  border: 2px solid #fff;
}
.layout-user-chip {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  padding: 6px 14px 6px 6px;
  border-radius: 999px;
  border: 1px solid var(--lo-stroke);
  cursor: pointer;
  transition: border-color 0.15s;
}
.layout-user-chip:hover {
  border-color: var(--lo-primary);
}
.layout-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: var(--lo-primary);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
}
.layout-user-info b {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: var(--lo-text);
}
.layout-user-info small {
  display: block;
  font-size: 11px;
  color: var(--lo-text-muted);
}

/* ── Content ────────────────────────────── */
.layout-content {
  flex: 1;
  padding: 32px;
  overflow-x: hidden;
  max-width: 100%;
  box-sizing: border-box;
}

/* ── Overlay ────────────────────────────── */
.layout-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.35);
  z-index: 65;
}

/* ── Responsive ─────────────────────────── */
@media (max-width: 1024px) {
  .layout-app {
    grid-template-columns: 1fr;
  }
  .layout-sidebar {
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    width: 280px;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    box-shadow: var(--lo-shadow-lg);
  }
  .layout-sidebar.open {
    transform: translateX(0);
  }
  .layout-mobile-toggle {
    display: flex;
  }
}
@media (max-width: 640px) {
  .layout-content {
    padding: 20px 16px;
  }
  .layout-topbar {
    padding: 0 12px;
    gap: 8px;
  }
  .layout-topbar-actions {
    flex-shrink: 0;
    gap: 8px;
  }
  .layout-user-info b,
  .layout-user-info small {
    display: none;
  }
  .layout-user-chip {
    padding: 4px;
  }
  .layout-icon-btn {
    width: 36px;
    height: 36px;
  }
}
`;
